let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kzoZ8")).then(() => parcelRequire('ejnrO'));